import React, { FunctionComponent, useState } from "react"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import DefaultLayout from "./layout/DefaultLayout/DefaultLayout"
import configureStore from "./store"
import { Provider } from "react-redux"
import "./style/index.less"
import "react-notifications-component/dist/theme.css"
import "animate.css/animate.min.css"
import PrivateRoute from "./components/Router/PrivateRoute"
import Login from "./pages/Login/Login"
import { useLogin } from "./hooks/useLogin"
import Loader from "./components/Loader/Loader"
import { contentRoutes } from "./Routes"
import ReactNotification from "react-notifications-component"

const store = configureStore()

const Page404: FunctionComponent = () => {
  return <div>Nothing found</div>
}

const App: FunctionComponent = () => {
  return (
    <Provider store={store}>
      <ReactNotification />
      <Router>
        <Dashboard />
      </Router>
    </Provider>
  )
}

const Dashboard: FunctionComponent = () => {
  const [loading, setLoading] = useState(true)
  useLogin(setLoading)

  return loading ? (
    <Loader />
  ) : (
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route>
        <DefaultLayout>
          {contentRoutes.map((route, i) => (
            <PrivateRoute key={i} {...route} />
          ))}
        </DefaultLayout>
      </Route>
      <Route component={Page404} />
    </Switch>
  )
}

export default App
